import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const buyers = [{
  name: 'María L.',
  location: 'Buenos Aires',
  time: 'hace 2 minutos'
}, {
  name: 'Sofía R.',
  location: 'Córdoba',
  time: 'hace 5 minutos'
}, {
  name: 'Laura M.',
  location: 'Rosario',
  time: 'hace 8 minutos'
}, {
  name: 'Carolina F.',
  location: 'Mendoza',
  time: 'hace 3 minutos'
}, {
  name: 'Valeria P.',
  location: 'Tucumán',
  time: 'hace 7 minutos'
}, {
  name: 'Ana G.',
  location: 'La Plata',
  time: 'hace 1 minuto'
}, {
  name: 'Paula T.',
  location: 'Salta',
  time: 'hace 4 minutos'
}, {
  name: 'Jimena B.',
  location: 'Mar del Plata',
  time: 'hace 6 minutos'
}, {
  name: 'Florencia C.',
  location: 'San Juan',
  time: 'hace 9 minutos'
}, {
  name: 'Gabriela L.',
  location: 'Entre Ríos',
  time: 'hace 2 minutos'
}, {
  name: 'Natalia M.',
  location: 'Neuquén',
  time: 'hace 11 minutos'
}, {
  name: 'Romina V.',
  location: 'Misiones',
  time: 'hace 3 minutos'
}, {
  name: 'Agustina F.',
  location: 'Jujuy',
  time: 'hace 6 minutos'
}, {
  name: 'Cecilia R.',
  location: 'Chaco',
  time: 'hace 4 minutos'
}, {
  name: 'Daniela D.',
  location: 'Santa Fe',
  time: 'hace 8 minutos'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(() => {
    return typeof window !== 'undefined' && sessionStorage.getItem('socialProofDismissed') === 'true';
  });
  const [scrollTriggered, setScrollTriggered] = useState(false);
  const showNotification = useCallback(() => {
    setVisible(true);
  }, []);
  const hideNotification = useCallback(() => {
    setVisible(false);
  }, []);
  const handleClose = useCallback(() => {
    setDismissed(true);
    setVisible(false);
    sessionStorage.setItem('socialProofDismissed', 'true');
  }, []);
  // Listen for scroll past 300px to trigger first appearance
  useEffect(() => {
    if (dismissed || scrollTriggered) return;
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setScrollTriggered(true);
        showNotification();
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [dismissed, scrollTriggered, showNotification]);
  // Auto-hide after 5 seconds when visible
  useEffect(() => {
    if (!visible) return;
    const hideTimer = setTimeout(() => {
      hideNotification();
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, hideNotification]);
  // Cycle to next buyer every 12 seconds (after hide)
  useEffect(() => {
    if (visible || dismissed) return;
    if (!scrollTriggered) return;
    const cycleTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % buyers.length);
      showNotification();
    }, 12000);
    return () => clearTimeout(cycleTimer);
  }, [visible, dismissed, scrollTriggered, showNotification]);
  const buyer = buyers[currentIndex];
  return <AnimatePresence data-id="element-359">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 left-4 z-[9999] max-w-[290px] rounded-lg border-l-[3px]" style={{
      backgroundColor: '#FFFFFF',
      borderLeftColor: '#52B788',
      boxShadow: '0 4px 16px rgba(0,0,0,0.1)'
    }} data-id="element-360">
          <div className="relative p-4 pr-8" data-id="element-361">
            {/* Close button */}
            <button onClick={handleClose} className="absolute top-2 right-2 text-gray-400 hover:text-brand-dark transition-colors" aria-label="Cerrar notificación" data-id="element-362">
              <XIcon className="w-4 h-4" data-id="element-363" />
            </button>

            {/* Verified badge */}
            <div className="inline-flex items-center gap-1.5 mb-2 px-2 py-0.5 rounded" style={{
          backgroundColor: '#52B788'
        }} data-id="element-364">
              <span className="relative flex h-2 w-2" data-id="element-365">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" data-id="element-366" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-white" data-id="element-367" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-368">
                Compra verificada
              </span>
            </div>

            {/* Buyer name */}
            <p className="text-sm font-bold leading-tight" style={{
          color: '#1A1A2E'
        }} data-id="element-369">
              {buyer.name} de {buyer.location}
            </p>

            {/* Product */}
            <p className="text-sm leading-tight mt-0.5" style={{
          color: '#4A4A6A'
        }} data-id="element-370">
              compró{' '}
              <span className="font-bold" style={{
            color: '#E84855'
          }} data-id="element-371">
                Megapack Premium
              </span>
            </p>

            {/* Time */}
            <p className="text-[11px] mt-1.5" style={{
          color: '#4A4A6A',
          opacity: 0.7
        }} data-id="element-372">
              {buyer.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}